import * as TankProfileActions from "@state/actions/tank-profile.actions";
import { ITankProfile } from "@interfaces/tankProfile";
import { ITankGridColumn } from "@interfaces/tankGridColumn";

const tpIninitialState: ITankProfile = {
  active:true,
  includeAffiliatedOrganization : false,
  includeChildOrganization : false,
  includeInactiveTanks : false,
  isNewUser: false,
  isTVP: false,
  maintenanceTanksOnly: false,
  organizationId: 0,
  organizationName: '',
  pageLength: 0,
  tankGridColumns: [],
  tankProfileId: 0,
  tankProfileName: '',
  tankViewProfileId: 0,
  userId: 0,
  isPrivate: true,
  isPersonal: true,
  isEditing: false
}

export function currentTankProfileReducer(state: ITankProfile = tpIninitialState,
  action: TankProfileActions.CurrentTankProfileActions
) {
  switch (action.type) {
    case TankProfileActions.UPDATE_CURRENT_TANK_PROFILE:
      return action.tankProfile;
    case TankProfileActions.GRID_COLUMN_VISIBILITY_TOGGLED:
      if (action.columnID) {
          return {
            ...state, tankGridColumns: state.tankGridColumns.map((tgc) => {
              if (tgc.columnID !== action.columnID) return tgc;
              return { ...tgc, isSelected: action.visible };
            })
          }
      }
      return state;
    case TankProfileActions.GRID_COLUMN_RESIZED:
      if (action.columnID) {
          return {
            ...state, tankGridColumns: state.tankGridColumns.map((tgc) => {
              if (tgc.columnID !== action.columnID) return tgc;
              return { ...tgc, width: action.width };
            })
          }
      }
      return state;
    case TankProfileActions.GRID_COLUMN_MOVED:
      if (action.columndId && action.toIndex > -1) {
          //setup new mutable array.
          let tgcs: ITankGridColumn[] = [...state.tankGridColumns];

          //find currentIndex
          let currentIx = tgcs.findIndex(c => c.columnID === action.columndId);
          let toIndex: number = action.toIndex;
          tgcs.splice(toIndex, 0, tgcs.splice(currentIx, 1)[0]);
          return { ...state, tankGridColumns: tgcs };
      }
      return state;
    case TankProfileActions.SET_GRID_COLUMN_ORDER:
      if (!action.colsByOrder)
        return state;

      let newTankGridColumns = action.colsByOrder.map(columnId => state.tankGridColumns.find(tgc => tgc.columnID === columnId));
      return { ...state, tankGridColumns: newTankGridColumns };

    default:
      return state;
  }

}
